"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesTasksLinkDeleteAsyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../../api/index.js");
const _lib_1 = require("../../../../lib/index.js");
const actions_1 = require("../../_idMap/actions.js");
exports.coreInitiativesTasksLinkDeleteAsyncSlice = (0, xuder_1.createDeleteAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            ({ initiativeId, initiativeTaskId, sonarObjectId }) => (0, actions_1.updateInitiativeReferences)([
                {
                    initiativeId,
                    tasks: {
                        toUpdateById: {
                            id: initiativeTaskId,
                            update: (entry) => (Object.assign(Object.assign({}, entry), { sonarObjects: (0, _lib_1.rebuildArray)(entry.sonarObjects, {
                                    toRemoveById: sonarObjectId
                                }, {
                                    idSelector: (task) => task.sonarObjectId
                                }) }))
                        }
                    }
                }
            ])
        ]
    },
    name: name_1.CoreInitiativesTasksLinkName,
    receive: false,
    request: true,
    requestHandler: _api_1.deleteInitiativeTaskLink
});
//# sourceMappingURL=delete.js.map